import { Component, OnDestroy, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';
import { KeretService } from '../../keret.service';
import { modeNev, modeFavicon } from '../../mode-nevek';
import { InventarioAktiv, InventarioService } from '../inventario.service';

/*  KÉSZLETKEZELÉS (INVENTARIO) – a modul kerete, a Számla és Kassza fejlécének párja (borostyán).
 *  (A korábbi leírás:) SZÁMLÁZÓ – a modul kerete. Fókusz témában a NAPLO/BÉR/Tárgyi eszköz fejlécének párja (sötét sáv a
 *  modul ikonjával, fülek, jobbra a cég + év és a profil), Klasszikusban egyszerű eszköztár (a menüt a
 *  bal sáv adja). A modul színe rózsapiros; a modálok a `body.inventario-aktiv` osztályról kapják.
 *
 *  A cégválasztó a látható cégeket kínálja SZEREPPEL: ügyfélként (a saját cég – ír) vagy könyvelőként
 *  (csak olvas). Könyvelői nézetben egy sáv jelzi, hogy itt nincs szerkesztés. */
@Component({
  selector: 'app-inventario-layout',
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.scss'],
})
export class InventarioLayoutComponent implements OnInit, OnDestroy {
  alrendszerNev = modeNev('INVENTARIO');
  modIkon = modeFavicon('INVENTARIO');
  aktiv: InventarioAktiv = { intezmeny: '', ugyfelId: null, ugyfelNev: null, szerep: null, ev: new Date().getFullYear() };
  readonly fulek: { ut: string; cim: string; ikon: string; tobb?: string[] }[] = [
    { ut: '/inventario/kezdolap', cim: 'Kezdőlap', ikon: 'home-outline' },
    { ut: '/inventario/cikkek', cim: 'Cikkek', ikon: 'pricetags-outline' },
    { ut: '/inventario/keszlet', cim: 'Készlet', ikon: 'cube-outline' },
    { ut: '/inventario/mozgasok', cim: 'Mozgások', ikon: 'swap-horizontal-outline' },
    { ut: '/inventario/leltar', cim: 'Leltár', ikon: 'barcode-outline' },
    { ut: '/inventario/ertekeles', cim: 'Értékelés', ikon: 'calculator-outline' },
    { ut: '/inventario/beallitasok', cim: 'Beállítások', ikon: 'settings-outline' },
  ];
  aktivUt = '';
  evek: number[] = [];

  valasztoNyitva = false;
  ugyfelek: any[] = [];
  kereso = '';

  private sub?: Subscription;
  private navSub?: Subscription;
  constructor(public router: Router, private keret: KeretService, private sz: InventarioService) {}

  get fokusz(): boolean { return this.keret.a?.tema() === 'fokusz'; }

  async ngOnInit() {
    await this.sz.init();
    this.sub = this.sz.aktiv$.subscribe((a) => (this.aktiv = a));
    await this.sz.kozosAtvesz();
    const most = new Date().getFullYear();
    this.evek = [most + 1, most, most - 1, most - 2, most - 3];
    this.utFrissit();
    this.navSub = this.router.events.pipe(filter((e) => e instanceof NavigationEnd)).subscribe(() => this.utFrissit());
    document.body.classList.add('inventario-aktiv');
    if (!this.aktiv.ugyfelId) this.valasztoNyit();
  }
  ngOnDestroy() { this.sub?.unsubscribe(); this.navSub?.unsubscribe(); document.body.classList.remove('inventario-aktiv'); }
  private utFrissit() { this.aktivUt = this.router.url.split('?')[0]; }

  /*  Az ügyfélválasztó saját oldal (components/modul-ugyfelek): csempe / lista, keresés, önálló
   *  módban új ügyfél is – a modul ügyfélkör-módja szerint (backend/ugyfeltorzs.js). */
  valasztoNyit() { if (!this.router.url.startsWith('/inventario/ugyfelek')) this.router.navigateByUrl('/inventario/ugyfelek'); }

  get lathatoUgyfelek(): any[] {
    const k = this.kereso.trim().toLowerCase();
    return k ? this.ugyfelek.filter((u) => String(u.nev || '').toLowerCase().includes(k) || String(u.adoszam || '').includes(k)) : this.ugyfelek;
  }
  async ugyfelValaszt(u: any) {
    this.valasztoNyitva = false;
    await this.sz.setAktiv({ ugyfelId: u.id, ugyfelNev: u.nev, szerep: u.szerep });
  }
  async evValt(ev: number) { await this.sz.setAktiv({ ev: Number(ev) }); }
  open(url: string) { this.router.navigateByUrl(url); }
}
